<template>
  <DatePicker
    expanded
    mode="date"
    :rules="rules"
    :model-value="date"
    :minDate="minDate"
    :maxDate="maxDate"
    @update:modelValue="$emit('dateSelected', $event)"
  />
</template>

<script setup>
import { DatePicker } from "v-calendar";
import { ref } from "vue";

defineEmits(["dateSelected"]);

defineProps({
  date: { type: Date, required: false },
  maxDate: { type: Date, default: null },
  minDate: { type: Date, default: null },
});

const rules = ref([
  {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  },
]);
</script>

<style lang="scss">
.vc-focus {
  box-shadow: none !important;

  &:focus-within {
    box-shadow: none !important;
  }
}
</style>
